// extracted by mini-css-extract-plugin
export default {"icon":"IconSample_icon__Dsv2W"};